import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const ScheduleIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"schedule"} ref={ref}/>
});

ScheduleIcon.displayName = "ScheduleIcon";
